import { MainLayout } from "../layout/MainLayout";
import MyRecentTasks from "./MyRecentTasks";
import FaqsBlock from "../blocks/FaqsBlock";
import FeedbackBlock from "../blocks/FeedbackBlock";
import { IntroMessage } from "../blocks/IntroMessage";
import { Beginnings } from "../blocks/Beginnings";

interface AppItemProps {
    name: string;
}

export default function Dashboard(props: AppItemProps) {
    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-lg-8">
                        <IntroMessage />
                        <MyRecentTasks />
                    </div>
                    <div className="col-xs-12 col-lg-4">
                        <Beginnings />
                        <FaqsBlock />
                    </div>
                </div>
            </div>
            <FeedbackBlock/>
        </MainLayout>);
}